import { Headers as NodeHeaders } from 'node-fetch';

export function getHeaders(headers?: Headers | NodeHeaders) {
  const useNativeFetch = typeof fetch !== 'undefined';

  const hdrs = useNativeFetch
    ? (headers as Headers) || new Headers()
    : (headers as NodeHeaders) || new NodeHeaders();

  return hdrs;
}
